export default __webpack_public_path__ + "8ec22c42e5ff72c4b79d61ef84cd4e48.svg";